// extracted by mini-css-extract-plugin
module.exports = {"paper":"ForgotPasswordForm_paper__vEolM","button":"ForgotPasswordForm_button__1naRs","message":"ForgotPasswordForm_message__vpoeM"};